module.exports = __webpack_public_path__ + "static/media/Leta Lestrange 2.b4fb95fb.jpg";